import React from "react";
import { Alert, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // console.log("er2",error)
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // console.log("er3",error,errorInfo)

    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ hasError: true, error: "null occured" });
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24 }}>
          <Alert severity="error" variant="filled">
            <strong>Something went wrong.</strong>
            <div>{this.state.error?.message}</div>
            <Button onClick={this.handleReload} color="inherit" sx={{ mt: 2 }}>
              Reload Page
            </Button>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
